// docs: https://github.com/altostra/type-validations#readme
import { anyOf, arrayOf, enumOf, maybe, objectOf } from "@altostra/type-validations";
import { boolean, nullValidation, number, string } from "@altostra/type-validations/lib/primitives";

import sharedConstants from "@lib/shared_constants";

export const isGetEngagementGetProductRecommenderPropertiesResult = objectOf({
  options: arrayOf(
    objectOf({
      value: string,
      label: string,
      score: maybe(number),
      is_recommended: maybe(boolean),
      example_values: maybe(arrayOf(string)),
    })
  ),
  is_automapped: boolean,
  match_status: enumOf(...Object.values(sharedConstants.RECOMMENDATIONS.MATCH_STATUSES)),
  catalog_has_matches: boolean,
  last_matched_at: anyOf(number, nullValidation),
});
